"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_VOUCHER_PARAM_KEY = void 0;
exports.ADD_VOUCHER_PARAM_KEY = 'addVoucher';
